// extracted by mini-css-extract-plugin
export default {"appBar":"DeNafdFSSnJeKacGXGqc","backButton":"j0ASJuR2RtuQe1x4GPCw","backIcon":"vcUseli7XQF44RSAY1vl"};